/**
 * Validation for user input in reporting modal
 **/
export const validateAdformReportingModal = (metrics: string[], dateFrom: string, dateTo: string, scope: string, campaignOrBannerStart: string, campaignOrBannerEnd: string) => {
  /* Form validation, throw error if no metrics are selected or invalid dates. Error notification is handled in the reporting modal component. */
  if (!metrics.length) throw new Error("Please select metrics to continue.");
  if (new Date(dateFrom) > new Date(dateTo)) throw new Error("Report start date must not exceed report end date.");
  if (new Date(dateFrom) < new Date(campaignOrBannerStart)) throw new Error(`Start date must not be before ${scope} start (${campaignOrBannerStart})`);
  if (new Date(dateTo) > new Date()) throw new Error("End date must not exceed todays' date");
  if (new Date(dateTo) > new Date(campaignOrBannerEnd)) throw new Error(`End date must not exceed ${scope} end (${campaignOrBannerEnd})`);
  return true;
};
